/* istanbul ignore file -- @preserve - can't mock this file, this is tested in the components that use it */

// nwsapi has a known issue with the 'is' selector, so setting focusable selectors
export const FOCUSABLE_SELECTORS: string =
  // eslint-disable-next-line @typescript-eslint/dot-notation
  process.env['VITEST_WORKER_ID'] == null
    ? /* istanbul ignore next -- added for test purpose only */ ':is(button, [href]:not(use), input:not([type="hidden"]), select, textarea, [tabindex]:not(li)):not([tabindex="-1"]):not([aria-hidden="true"]):not([aria-hidden="true"] > input)'
    : (undefined as unknown as string);

export const targetContainsFocusableElements = (target: EventTarget, currentTarget: HTMLElement): boolean => {
  return !Array.from(currentTarget.querySelectorAll(FOCUSABLE_SELECTORS)).some(el => el.contains(target as Node));
};
